export enum AutenticaModule {
  Jorneys = 'jornadas',
  Signatures = 'assinaturas',
}
